import { render, staticRenderFns } from "./fourjiao.vue?vue&type=template&id=3a956b46&scoped=true&"
import script from "./fourjiao.vue?vue&type=script&lang=js&"
export * from "./fourjiao.vue?vue&type=script&lang=js&"
import style0 from "./fourjiao.vue?vue&type=style&index=0&id=3a956b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a956b46",
  null
  
)

export default component.exports